function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "en");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 24,
  height: 48
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "en",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  fill: "#012681",
  x: 0,
  y: 0,
  width: 24,
  height: 48
}), React.createElement("g", {
  id: "Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-+-Rectangle-Mask"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "Mask"
}), React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  mask: "url(#mask-2)",
  transform: "translate(15.000000, 42.500000) rotate(45.000000) translate(-15.000000, -42.500000) ",
  x: -17,
  y: 39,
  width: 64,
  height: 7
}), React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  mask: "url(#mask-2)",
  transform: "translate(15.000000, 5.500000) rotate(-45.000000) translate(-15.000000, -5.500000) ",
  x: -17,
  y: 2,
  width: 64,
  height: 7
}), React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  mask: "url(#mask-2)",
  x: 0,
  y: 17,
  width: 24,
  height: 14
}), React.createElement("rect", {
  id: "Rectangle",
  fill: "#D2142E",
  mask: "url(#mask-2)",
  transform: "translate(15.000000, 5.500000) rotate(-45.000000) translate(-15.000000, -5.500000) ",
  x: -17,
  y: 4,
  width: 64,
  height: 3
}), React.createElement("rect", {
  id: "Rectangle",
  fill: "#D2142E",
  mask: "url(#mask-2)",
  transform: "translate(15.000000, 42.500000) rotate(45.000000) translate(-15.000000, -42.500000) ",
  x: -17,
  y: 41,
  width: 64,
  height: 3
}), React.createElement("rect", {
  id: "Rectangle",
  fill: "#D2142E",
  mask: "url(#mask-2)",
  x: 0,
  y: 20,
  width: 24,
  height: 8
})));

var SvgEn = function SvgEn(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "48px",
    viewBox: "0 0 24 48",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/en.8fca0a27.svg";
export { ForwardRef as ReactComponent };